import { Injectable, OnDestroy } from '@angular/core';
import { GraphQLFundDataService } from '@products/services/graphql-fund-data.service';
import query from '@graphql/fund-listing/exchange-rate.graphql';
import { Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { ExchangeRateDTO } from '../types/dto/exchange-rate.dto.type';
import { ExchangeRate } from '../types/exchange-rate.type';
import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { MapperParams } from '@products/utils/mappers/type.mapper';
import { SiteConfigService } from '@services/site-config.service';
import { TranslateService } from '@shared/translate/translate.service';
import { ExchangeRateSetMapper } from '../utils/mappers/exchange-rate.type.mapper';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExchangeRateService implements OnDestroy {
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private fundDataService: GraphQLFundDataService,
    protected siteConfigService: SiteConfigService,
    private translateService: TranslateService,
    private mapperFactory: MapperFactory
  ) {}

  /**
   * this requests the exchange rate data from gql
   * data is specific to country and language, so only needs requested once
   */
  public requestData(): Observable<ExchangeRate[]> {
    return this.fundDataService
      .register(query, {
        countrycode: this.fundDataService.getCountry(),
        languagecode: this.fundDataService.getLanguage(),
      })
      .pipe(
        takeUntil(this.unsubscribe$),
        map((rawExchangeRateData) => {
          const exchangeRateDTO: ExchangeRateDTO[] =
            rawExchangeRateData?.data?.ExchangeRate || null;

          const mapperParams: MapperParams = {
            config: this.siteConfigService,
            translateService: this.translateService,
          };

          const exchangeRateData: ExchangeRate[] = this.mapperFactory
            .createMapper(ExchangeRateSetMapper, mapperParams)
            .toDomain(exchangeRateDTO);

          return exchangeRateData;
        })
      );
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
